<template>
    <div>
        <div class="morm_app">
            <div class="morm_app_list" v-for="item in mormTitle" :key="item.id" @click="titleFun(item)">
                <p class="type_app_list">{{item.name}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import Bus from '@/Bus';
export default {
    data(){
        return {
            mormTitle:[
                {
                    id:1,
                    name:'首页',
                    jump:'/m_index'
                },
                // {
                //     id:2,
                //     name:'推荐',
                //     jump:"{path:'/detailsList', query: {  id: '5cc57db80cf2c3d1b7e9d4de' , titleName : '推荐', typeNum : 1 }}"
                // },{
                //     id:3,
                //     name:'习近平时间',
                //     jump:'/m_index'
                // },
                {
                    id:4,
                    name:'时政快讯',
                    jump:'/m_index'
                },{
                    id:5,
                    name:'手机报',
                    jump:'/m_index'
                },{
                    id:6,
                    name:'公示公告',
                    jump:'/m_index'
                },{
                    id:7,
                    name:'濮阳要闻',
                    jump:'/m_index'
                },{
                    id:8,
                    name:'综合新闻',
                    jump:'/m_index'
                },{
                    id:9,
                    name:'龙乡新闻',
                    jump:'/m_index'
                }
            ]
        }
    },
    methods:{
        titleFun(item){
            Bus.$emit('stateListShoot',false);
            if(item.id == 1){
                this.$router.push({path:'/m_index'})
            }
            // else if(item.id == 2){
            //     this.$router.push({path:'/recommended', query: {  id: '5cc57db80cf2c3d1b7e9d4de' , titleName : '推荐', typeNum : 1 }})
            // }else if(item.id == 3){
            //     this.$router.push({path:'/xjptime', query: {  id: '5cc57db80cf2c3d1b7e9d4dd' , titleName : '习近平时间', typeNum : 2 }})
            // }
            else if(item.id == 4){
                this.$router.push({path:'/currentpoliticsa', query: {  id: '5e09ab7ce4b0b14aa6e2e642' , titleName : '时政快讯' , typeNum : 1}})
            }else if(item.id == 6){
                this.$router.push({path:'/publiclist', query: {  id: '5d68ce5de4b0e2963a408843' , titleName : '公示公告' , typeNum : 1}})
            }else if(item.id == 7){
                this.$router.push({path:'/newslist', query: {  id: '8b6b1c0a-ad07-4dfa-97a5-355fcec9c46d' , titleName : '濮阳要闻' , typeNum : 1}})
            }else if(item.id == 9){
                this.$router.push({path:'/lxlist', query: {  id: 'b6fa79eb-d01e-49fe-a033-3fd6f1a8631a' , titleName : '龙乡新闻' , typeNum : 1}})
            }else if(item.id == 8){
                this.$router.push({path:'/comprehensivelist', query: {  id: '5d6cc95ce4b0e2963a408933' , titleName : '综合新闻' , typeNum : 1}})
            }else if(item.id == 5){
                this.$router.push({path:'/phonelist', query: {  id: '5287fdce-892d-4eb0-a147-5047637fdd7c' , titleName : '手机报', typeNum : 1 }})
            }
        }
    }
}
</script>
<style lang="">
    .morm_app{
        width:100vw;
    }
    .morm_app .morm_app_list{
        margin: 0.4rem 0.6rem;
        
    }
    .morm_app .morm_app_list .type_app_list{
        font-size:1.2rem;
        padding-left:0.6rem;
        background:#f0f0f0;
        height:2.5rem;
        line-height:2.5rem;
    }
    .morm_app_list .type_app_content{
        padding:0.4rem 0;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        text-align: center;
    }
    .morm_app_list .type_app_content li{
        width:6rem;
        height:2rem;
        font-size:0.8rem;
        line-height: 2rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/appModule/bouncedMormApp/mormComponent.vue